import {
    FetchState,
    HsabAccountNametag,
    HsabAccountType,
} from "@/shared/types";

import { defineStore } from "pinia";
import _ from "lodash";
import { getHsabAccountTypes as bankServiceGetHsabAccountTypes, getHsabAccountTypesAdmin } from "@/shared/api/bankService";
import { handleError as storeHelperHandleError } from "@/shared/storeHelper";
import { HsabAccountState } from "@/employer/types";
import { useUserStore } from "@/shared/store/user";
import { getSsoLink } from "@/shared/api/userService";

export const initialState: HsabAccountState = {
    fetchState: FetchState.Uninitialized,
    account: null,
    username: "",
    wexLink: ""
};

export const useHsaAccountStore = defineStore("hsaAccounts", {
    state: () => (_.cloneDeep(initialState)),
    actions: {
        setWexSsoLink (wexSsoLink: string) {
            this.wexLink = wexSsoLink;
        },
        getWexSsoLink () {
            return this.wexLink;
        },
        setHsaAccount (data: HsabAccountNametag) {
            this.account = data;
            this.fetchState = FetchState.Loaded;
        },
        getHsaAccount (args: { username: string, partnerId: number}): Promise<any> {
            if (this.username === args.username) {
                return;
            }

            this.username = args.username;
            this.fetchState = FetchState.Loading;

            return fetchHsabAccounts(args)
            .then(response => {
                const foundAccount = response.data.accounts.find(item => item.bankAccountType === HsabAccountType.Hsa);
                this.setHsaAccount(foundAccount);
            })
            .catch(err => {
                this.fetchState = FetchState.Failed;
                return storeHelperHandleError({ error: err, rethrow: true });
            });
        },
        getWexLink () {
            return getSsoLink()
                .then(response => {
                    if (!response || !response.data || !response.data.samlProviderUrl) {
                        throw new Error(("Failed to get WEX SSO link"));
                    }

                    this.setWexSsoLink(response.data.samlProviderUrl);
                })
                .catch(err => {
                    return storeHelperHandleError({ error: err, rethrow: true });
                });
        },
    }
});

function fetchHsabAccounts (args: { username: string, partnerId: number}) {
    const userStore = useUserStore();
    return userStore.isAdminPortal
        ? getHsabAccountTypesAdmin(args)
        : bankServiceGetHsabAccountTypes(args);
}